<template>
  <InvoiceParameterDefaultModal
    title="Confirmar informações"
    width="840"
    :show="show"
    @close="confirm(false)">
    <template slot="body">
      <div>
        <TextBase>
          Você deseja continuar com os dados informados?
        </TextBase>
        <TextBase>
          Verifique se todas as regras e campos preenchidos estão corretos antes de prosseguir.
        </TextBase>
        <v-divider class="my-4" />
      </div>
      <v-data-table
        hide-default-footer
        mobile-breakpoint="0"
        :headers="headers"
        :items="[{}, {}]">
        <template
          v-slot:[`header.type`]>
          <Header>Tipo de Nível</Header>
        </template>
        <template
          v-slot:[`header.entity`]>
          <Header>Opção do Nível</Header>
        </template>
        <template
          v-slot:[`header.rule`]>
          <Header>Regra</Header>
        </template>
        <template
          v-slot:[`header.description`]>
          <Header>Descrição</Header>
        </template>
        <template
          v-slot:[`header.value`]>
          <Header>Valor</Header>
        </template>
        <template
          v-slot:[`header.status`]>
          <Header>Status</Header>
        </template>

      </v-data-table>
    </template>
    <template slot="actions">
      <div
        class="d-flex justify-end gap-h-20 fill-width">
        <v-btn
          class="action-button-modal"
          color="primary"
          outlined
          @click="confirm(false)">
          Cancelar
        </v-btn>
        <v-btn
          class="action-button-modal"
          color="primary"
          @click="confirm(true)">
          Confirmar
        </v-btn>
      </div>
    </template>
  </InvoiceParameterDefaultModal>
</template>
<script>
import InvoiceParameterDefaultModal from './InvoiceParameterDefaultModal.vue';
import InvoiceParameterHeader from '../components/InvoiceParameterHeader.vue';
import InvoiceParameterText from '../components/InvoiceParameterText.vue';
import { mapMutations } from 'vuex';
export default {
  name: "ConfirmInfoModal",
  components: {
    InvoiceParameterDefaultModal,
    Header: InvoiceParameterHeader,
    TextBase: InvoiceParameterText,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    }
  },
  methods: {
    ...mapMutations({
      setShowConfirmInfoModal: 'invoice-parameter/setShowConfirmInfoModal',
    }),
    confirm(confirmation) {
      this.$emit('confirm', confirmation);
      this.setShowConfirmInfoModal(false);
    }
  },
  computed: {
    headers() {
      return [
        { value: 'type', sortable: false },
        { value: 'entity', sortable: false },
        { value: 'rule', sortable: false },
        { value: 'description', sortable: false },
        { value: 'value', sortable: false },
        { value: 'status', sortable: false },
      ];
    },
  }
}
</script>
<style lang="scss">
@import "@/shared/styles/invoiceParameters/default.scss";
</style>